module.exports = __webpack_public_path__ + "img/blog-3.bee8b1e3.webp";